import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportesRoutingModule } from './reportes-routing.module';
import { AvanceSegComponent } from './avance-seg/avance-seg.component';
import { SharedModule } from '../../shared/shared.module';
import { PlanEstrategicoComponent } from './plan-estrategico/plan-estrategico.component';


@NgModule({
  declarations: [
    AvanceSegComponent,
    PlanEstrategicoComponent
  ],
  imports: [
    CommonModule,
    ReportesRoutingModule,
    SharedModule
  ]
})
export class ReportesModule { }
